import { API } from "."
import { makeParams } from "@/utils/helper"
import { CreateResendInvitationPayload, ReadTeamInvitationsResponse } from "@/types/invitation"

/* 호출 시 interceptor 에서 /teams/{idfTeam} 붙음 */

/* 미승인 초대 조회 */
export async function readTeamInvitations(role: string) {
  const params = makeParams({ role })

  return await API.get<ReadTeamInvitationsResponse>("/invitations", { params })
}

/* 초대 이메일 재전송 */
export async function createResendInvitation(payload: CreateResendInvitationPayload) {
  const { idfInvitation } = payload

  return await API.post<void>(`/invitations/${idfInvitation}/resend-mail`, payload)
}

/* 초대 제거 */
export async function deleteInvitation(idfInvitation: number) {
  return await API.delete<void>(`/invitations/${idfInvitation}`)
}
